import { render, staticRenderFns } from "./star-filled.vue?vue&type=template&id=3d6a273e"
import script from "./star-filled.vue?vue&type=script&lang=js"
export * from "./star-filled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports